// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/locale-provider/style/index.less
// module id = 1762
// module chunks = 0